import { normalize, placeholder, seeded, POOL, hashIndex, bucketFor } from "./imageDefaults";

// --- ASSET LOADER ---
// Load all PNGs from src/assets/categories using Webpack's require.context
let CATEGORY_ASSET_MAP = {};
try {
  const categoryContext = require.context("../assets/categories", false, /\.png$/);

  categoryContext.keys().forEach((key) => {
    const path = categoryContext(key);
    const fileName = key.replace("./", "").replace(".png", "");
    // Group images by base name (removing -1, -2, etc)
    const baseName = normalize(fileName.replace(/[-_ ]?\d+$/, "").replace(/\s*\(?\d+\)?$/, ""));
    if (!CATEGORY_ASSET_MAP[baseName]) CATEGORY_ASSET_MAP[baseName] = [];
    CATEGORY_ASSET_MAP[baseName].push(path);
  });
} catch (e) {
  console.warn("Category assets context not available", e);
}

// Load all PNGs from src/assets using Webpack's require.context
let ASSET_MAP = {};
try {
  const assetContext = require.context("../assets", false, /\.png$/);

  assetContext.keys().forEach((key) => {
    const path = assetContext(key);
    const fileName = key.replace("./", "").replace(".png", "");
    // Group images by base name (removing -1, -2, etc)
    const baseName = normalize(fileName.replace(/[-_ ]?\d+$/, "").replace(/\s*\(?\d+\)?$/, ""));
    if (!ASSET_MAP[baseName]) ASSET_MAP[baseName] = [];
    ASSET_MAP[baseName].push(path);
  });
} catch (e) {
  console.warn("Assets context not available", e);
}

const findInAssets = (name, slug, index, isCat = false) => {
  const key = normalize(name);
  const slugKey = normalize(slug);

  // Search in categories folder first
  const catList = CATEGORY_ASSET_MAP[key] || CATEGORY_ASSET_MAP[slugKey];
  if (catList && catList.length > 0) {
    return catList[index % catList.length];
  }

  // Search in general assets folder next
  const list = ASSET_MAP[key] || ASSET_MAP[slugKey];
  if (list && list.length > 0) {
    return list[index % list.length];
  }

  return null;
};

export function pickImage(slug, name, index = 0, isCategory = false) {
  // ONLY for category routes (when explicitly flagged), check local assets (categories + general assets fallback)
  if (isCategory) {
    const local = findInAssets(name, slug, index, true);
    if (local) return local;

    // Fallback directly to SVG placeholder if not found locally
    return placeholder(name);
  }

  // For all other routes (e.g. homepage), skip assets check and go straight to Unsplash/Pexels curated pool
  const bucket = bucketFor(name);
  const list = POOL[bucket] || POOL.promo;
  // Pick deterministic primary; rotate for gallery slots.
  const base = hashIndex(slug, list.length);
  if (index < 3) return list[(base + index) % list.length];
  
  // Last resort: unique seeded placeholder
  return seeded(slug, index + 1);
}

export function pickGallery(slug, name, isCategory = false) {
  const gallery = [];
  for (let i = 0; i < 4; i++) {
    gallery.push(pickImage(slug, name, i, isCategory));
  }
  return gallery;
}
